// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__niz0i","type":"styles_type__3S5iB","choices":"styles_choices__3tuxb"};